import {ESLMediaRuleList} from '@exadel/esl/modules/esl-media-query/core';

import BREAKPOINTS from '../config/breakpoints.json';

export {BREAKPOINTS};

export type BreakpointName = keyof typeof BREAKPOINTS;

/** Reusable constant with full breakpoints list query */
export const DEFAULT_BP_TUPLE = '@xs|@sm|@md|@lg|@xl';
/** Reusable constant with full list of main breakpoints */
const DEFAULT_BP_NAMES_TUPLE = 'xs|sm|md|lg|xl';

/** Reusable {@link ESLMediaRuleList} constant that observes main breakpoints state change */
export const DEFAULT_BP_QUERY = ESLMediaRuleList.parseTuple(DEFAULT_BP_TUPLE, DEFAULT_BP_NAMES_TUPLE);

/** @deprecated use {@link ESLMediaQuery} */
export function parseViewportItems(
  viewportString: string,
  keyMapper?: (breakpoint: string, value: string) => string
): Record<string, number>;
/** @deprecated use {@link ESLMediaQuery} */
export function parseViewportItems<V>(
  viewportString: string,
  keyMapper: (breakpoint: string, value: string) => string,
  valueMapper: (breakpoint: string, value: string) => V
): Record<string, V>;
export function parseViewportItems(
  viewportString: string,
  keyMapper: (breakpoint: string, value: string) => string = (breakpoint) => breakpoint,
  valueMapper: (breakpoint: string, value: string) => any = (breakpoint, value) => +value
): Record<string, any> {
  const breakpoints = Object.keys(BREAKPOINTS);
  const viewportObject: Record<string, any> = {};
  viewportString.split('|').forEach((value) => {
    const breakpoint = breakpoints.shift();
    const key = keyMapper(breakpoint, value);
    if (typeof key === 'string' || typeof key === 'number') {
      viewportObject[key] = valueMapper(breakpoint, value);
    }
  });
  return viewportObject;
}
